/**
 * API Configuration
 * Zentrale Konfiguration für API-Aufrufe
 * Erkennt automatisch, ob die Seite auf Production läuft
 */

/**
 * Prüft, ob die Seite auf Production läuft (nicht auf dev/pages)
 * @returns {boolean} true wenn Production, false wenn Development
 */
export const isProduction = () => {
  if (typeof window === 'undefined') {
    // Server-side rendering
    return process.env.NODE_ENV === 'production';
  }

  const hostname = window.location.hostname;
  const port = window.location.port;

  // Development-Indikatoren
  const isDev = 
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('pages.dev') ||
    hostname.includes('vercel.app') ||
    hostname.includes('netlify.app') ||
    hostname.includes('github.io') ||
    hostname.includes('github-pages') ||
    hostname.includes('.pages.dev') ||
    port === '3000' ||
    port === '5173' ||
    port === '5174';

  // Production: Prüfe gegen konfigurierte Production-Domains
  const productionDomains = process.env.REACT_APP_PRODUCTION_DOMAINS 
    ? process.env.REACT_APP_PRODUCTION_DOMAINS.split(',').map(d => d.trim())
    : ['derponystall.de', 'www.derponystall.de'];
  
  const isProductionDomain = productionDomains.some(domain => 
    hostname === domain || hostname.endsWith(`.${domain}`)
  );

  return isProductionDomain && !isDev;
};

/**
 * Gibt die API Base URL zurück
 * Priorität:
 * 1. REACT_APP_API_URL aus .env (höchste Priorität)
 * 2. Standard: /api (relativer Pfad) - funktioniert in Development und Production
 * @returns {string} API Base URL
 */
export const getApiBaseUrl = () => {
  // Wenn REACT_APP_API_URL in .env gesetzt ist, diese verwenden
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Standard: relativer Pfad /api - funktioniert auf derselben Domain
  // Im Development wird der Proxy verwendet, im Production läuft alles auf demselben Server
  return '/api';
};

/**
 * Erstellt eine vollständige API-URL aus einem Endpoint
 * @param {string} endpoint - API Endpoint (z.B. '/public/courses')
 * @returns {string} Vollständige API URL
 */
export const getApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

export default {
  isProduction,
  getApiBaseUrl,
  getApiUrl
};

